import { prepareFilteredIds, setFilteredIds } from './files/actions';
import { getIds, getFilteredIds, getFilesFromIds }  from './files/reducer';
import { getIds as getFundIds } from './funds/reducer';
import { getIds as getCircleIds } from './circles/reducer';
import { getIds as getTypeIds } from './types/reducer';
import { getIds as getYearIds } from './years/reducer';
import {
	TOGGLE_CIRCLES,
	TOGGLE_CIRCLE,
	TOGGLE_TYPES,
	TOGGLE_TYPE,
	TOGGLE_FUNDS,
	TOGGLE_FUND,
	TOGGLE_YEARS,
	TOGGLE_YEAR,
	CLEAR_FILTERS,
	SET_FILTERED_CIRCLES,
	SET_FILTERED_TYPES,
	SET_FILTERED_FUNDS,
	SET_FILTERED_YEARS,
	CLOSE_DROPDOWNS,
} from './types';

export const closeDropdowns = () => {
	return {
		type: CLOSE_DROPDOWNS
	}
}

export const toggleDropdown = dropdown => {
	switch (dropdown) {
		case 'circles':
			return {
				type: TOGGLE_CIRCLES
			}
			
		case 'types':
			return {
				type: TOGGLE_TYPES
			}

		case 'funds':
			return {
				type: TOGGLE_FUNDS
			}

		case 'years':
			return {
				type: TOGGLE_YEARS
			}

		default:
			return;
	}
}

export const toggleCheckFilter = (dropdown, id, selected) => {
	return dispatch => {
		switch (dropdown) {
			case 'circles':
				dispatch({
					type: TOGGLE_CIRCLE,
					payload: {id, selected},
				});
				break;
			
			case 'types':
				dispatch({
					type: TOGGLE_TYPE,
					payload: {id, selected},
				});
				break;
			
			case 'funds':
				dispatch({
					type: TOGGLE_FUND,
					payload: {id, selected},
				});
				break;
	
			case 'years':
				dispatch({
					type: TOGGLE_YEAR,
					payload: {id, selected},
				});
				break;

			default:
				return;
		}

		dispatch(prepareFilteredIds);
		dispatch(setFilteredCheckFilters());
	}
}

export const clearFilters = () => {
	return (dispatch, getState) => {
		const state = getState();
		const ids = getIds(state.files);

		dispatch(setFilteredIds(ids));
		return dispatch({
			type: CLEAR_FILTERS,
			payload: {
				funds: getFundIds(state.funds),
				circles: getCircleIds(state.circles),
				types: getTypeIds(state.types),
				years: getYearIds(state.years),
			}
		});
	}
}

const setFilteredCheckFilters = () => { 
	return (dispatch, getState) => {
		const files = getState().files;
		const filteredIDS = getFilteredIds(files)
		const filteredFiles = getFilesFromIds(files, filteredIDS);

		//get the filtered circles
		const filteredCircles = [];
		for (const file of filteredFiles) {
			for (const circle of file.circles) {
				if (!filteredCircles.includes(circle)) {
					filteredCircles.push(circle);
				}
			}
		}

		//get the filtered types
		const filteredTypes = [];
		for (const file of filteredFiles) {
			for (const type of file.types) {
				if (!filteredTypes.includes(type)) {
					filteredTypes.push(type);
				}
			}
		}

		//get the filtered funds
		const filteredFunds = [];
		for (const file of filteredFiles) {
			for (const fund of file.funds) {
				if (!filteredFunds.includes(fund)) {
					filteredFunds.push(fund);
				}
			}
		}

		//get the filtered years
		const filteredYears = [];
		for (const file of filteredFiles) {
			for (const year of file.years) {
				if (!filteredYears.includes(year)) {
					filteredYears.push(year);
				}
			}
		}
		filteredYears.sort((a,b) => (a-b));

		dispatch({
			type: SET_FILTERED_CIRCLES,
			payload: filteredCircles,
		});
		dispatch({
			type: SET_FILTERED_TYPES,
			payload: filteredTypes,
		});
		dispatch({
			type: SET_FILTERED_FUNDS,
			payload: filteredFunds,
		});
		dispatch({
			type: SET_FILTERED_YEARS,
			payload: filteredYears,
		});
	}
}


// WEBPACK FOOTER //
// ./src/store/actions.js